﻿
import { Options as ChartConfigOptions } from "ol/source/XYZ";
import { ExternalChartLayer } from "../components/externalLayers/LayerInterfaces";
import { IColorScale } from "./ColorScale";

export interface IChartConfig {
    chartLayer?: ChartConfigOptions,
    wmsLayer?: ChartConfigOptions,
    osmLayer?: ChartConfigOptions,
    osmVectorLayer?: ChartConfigOptions,
    satelliteLayer?: ChartConfigOptions
}

export interface IChartState {
    type: ChartType,
    hybrid: ChartHybrid,
    background: ChartBackground,
    detail: ChartDetail,
    brightness?: number,
    bathymetry?: IBathymetryState,
    layerDetailLevel?: string
}

export interface IChartWmsState {
    showCustomDepthContours: boolean,
    useCustomDepthContours: boolean,
    shallowContour: number,
    deepContour: number,
    safetyDepth: number,
    safetyDepthIsCalculated: boolean,
    keelClearance: number,
    keelClearanceIsRelative: boolean,
    shipDraught: number,
    tide: number,

    showCustomDepthContourInterval: boolean,
    useCustomDepthContourInterval: boolean,
    depthContourInterval: number,
}    

export interface IExternalLayersState {
    layers?: ExternalChartLayer[],
    selectedLayerId: number,
    enableLayerAdmin: boolean,
}

export interface IBathymetryState {
    colorScales?: IColorScale[],
    colorScaleLegend?: boolean;
    spaceId?: number;
    depthShallow: number,
    depthDeep: number,
    hillShading: boolean,
    terrainExaggeration: number
}

export enum ChartType {
    None = -1,
    Paper = 0,
    ECDIS = 1,
    OpenStreetMap = 2,
    Satellite = 3
}

export enum ChartHybrid {
    None = 0,
    Bathymetry = 1,
    Land = 2,
}

export enum ChartBackground {
    OpenStreetMap = 0,
    Satellite = 1,
}

export enum ChartDetail {
    Low = 0,
    High = 1,
    ExtraHigh = 2,
}

export interface IChartStateOptions {
    visibility?: IChartVisibility
}

export interface IBathymetryStateOptions extends IChartStateOptions {
    type?: ChartType;
}

export interface IChartVisibility {    
    type?: boolean,
    detail?: boolean,
    hybrid?: boolean,
    background?: boolean,
    brightness?: boolean,
    bathymetry?: boolean,
   
    typeKeys?: KeyVisibility<ChartType>,
    detailKeys?: KeyVisibility<ChartDetail>,
    hybridKeys?: KeyVisibility<ChartHybrid>,
    backgroundKeys?: KeyVisibility<ChartBackground>,

    bathymetryProperties?: IBathymetryVisibility,
}

export interface KeyVisibility<T> {
    show?: T[],
    hide?: T[]
}

export interface IBathymetryVisibility {
    colorScale?: boolean,
    colorScaleLegend?: boolean,
    depthShallow?: boolean,
    depthDeep?: boolean,
    hillShading?: boolean,
    terrainExaggeration?: boolean,
    disabledColorScaleSpaceIds?: number[];
}

export const isEmptyChart = (state: IChartState) => state.type === ChartType.None;
export const isMsgChart = (state: IChartState) => state.type === ChartType.Paper || state.type == ChartType.ECDIS;
export const isStandAloneChart = (state: IChartState) => state.type === ChartType.OpenStreetMap || state.type === ChartType.Satellite;
